import { useAtomValue } from 'jotai';

export const SocialLink = ({ url, icon: Icon }: { url: string; icon: React.ElementType }) => {
  return url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-400 hover:text-blue-400 transition-colors"
    >
      <Icon size={16} />
    </a>
  ) : null;
};
